import React, { useState, useEffect } from "react";
import { useApp } from "context";
import { Store } from "utils";
import { IEvent } from "interfaces";

type Props = {
  event: IEvent;
  handleOpenEventModal: (event: IEvent) => void;
};

export const BigCalendarEvent = (props: Props) => {
  const { t, theme } = useApp();

  const isClinicEvent = props.event.providerId === null;

  useEffect(() => {
    props.event.eId === -1 && props.handleOpenEventModal(props.event);
  }, [props.event]);

  const style = { marginTop: "0.5rem" };

  return (
    <>
      <div style={style}>{props.event.owner}</div>
      <div style={style}>
        {isClinicEvent
          ? props.event.title ?? "Other"
          : props.event.title?.replace(
              "Provider",
              props.event.isPrimary ? "Primary" : "Secondary"
            )}
      </div>
      {!isClinicEvent && (
        <div style={style}>
          {props.event.isConfirmed ? "Confirmed" : "Pending"}
        </div>
      )}
    </>
  );
};
